import React from "react";

function Footer() {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <footer>
      <div className="footer-grid">
        <div className="footer-brand">
          <a
            href="#"
            className="nav-logo"
            onClick={(e) => {
              e.preventDefault();
              scrollToSection("home");
            }}
          >
            Mani <span style={{ color: "var(--gold)" }}>Spa & Retreat</span>
          </a>
          <p className="footer-desc">
            A sanctuary of peace and indulgence where every detail is crafted
            for your comfort and well-being.
          </p>
          <div className="footer-social">
            {["f", "in", "tw", "yt"].map((s) => (
              <a href="#" className="social-icon" key={s}>
                {s === "f" ? "𝐟" : s === "in" ? "𝐢" : s === "tw" ? "𝕏" : "▶"}
              </a>
            ))}
          </div>
        </div>
        {[
          {
            heading: "Services",
            links: [
              "Thai Massage",
              "Swedish Massage",
              "Hot Stone",
              "Aromatherapy",
              "Deep Tissue",
              "Balinese Massage",
            ],
          },
          {
            heading: "Company",
            links: [
              "About Us",
              "Our Team",
              "Gallery",
              "Pricing",
              "Blog",
              "Contact",
            ],
          },
          {
            heading: "Contact",
            links: ["+91 9521713060"],
          },
        ].map((col) => (
          <div key={col.heading}>
            <div className="footer-heading">{col.heading}</div>
            <ul className="footer-links">
              {col.links.map((l) => (
                <li key={l}>
                  <a
                    href="#"
                    onClick={(e) => {
                      e.preventDefault();
                      if (l === "About Us") scrollToSection("about");
                      else if (l === "Gallery") scrollToSection("gallery");
                      else if (l === "Pricing") scrollToSection("pricing");
                      else if (l === "Contact") scrollToSection("contact");
                    }}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="footer-bottom">
        <span>© 2026 Mani Spa & Retreat. All rights reserved.</span>
        <div style={{ display: "flex", gap: 24 }}>
          <a href="#">Privacy Policy</a>
          <a href="#">Terms of Service</a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
